import React, { useState } from 'react';
import { BillingPage } from './components/BillingPage';
import { MenuIcon, XIcon } from 'lucide-react';
export function App() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-0">
      {/* Mobile Menu Button */}
      {!isMobileMenuOpen && <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden fixed top-2 left-4 z-50 p-2 rounded-md bg-white shadow-md" data-id="element-1">
          <MenuIcon className="h-6 w-6 text-gray-600" data-id="element-2" />
        </button>}
      {/* Overlay */}
      {isMobileMenuOpen && <div className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden" onClick={() => setIsMobileMenuOpen(false)} data-id="element-3" />}
      {/* Sidebar */}
      <div className={`fixed lg:static lg:flex z-40 w-56 min-h-screen bg-white border-r border-gray-200 transform transition-transform duration-200 ease-in-out ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`} data-id="element-4">
        <Sidebar data-id="element-5" />
      </div>
      {/* Main Content */}
      <main className="flex-1 lg:ml-56" data-id="element-6">
        <div className="h-16 lg:hidden" data-id="element-7" /> {/* Mobile spacing for header */}
        <BillingPage data-id="element-8" />
      </main>
    </div>;
}
const Sidebar = () => {
  return <div className="w-56 min-h-screen bg-white flex flex-col" data-id="element-9">
      <div className="p-4 border-b border-gray-200" data-id="element-10">
        <div className="flex items-center" data-id="element-11">
          <div className="w-6 h-6 bg-blue-600 rounded mr-2" data-id="element-12"></div>
          <span className="text-lg font-semibold" data-id="element-13">BlendAI</span>
        </div>
      </div>
      <nav className="flex-1 p-4" data-id="element-14">
        <ul className="space-y-1" data-id="element-15">
          <SidebarItem label="Home" active={false} data-id="element-16" />
          <SidebarItem label="Blend" active={false} data-id="element-17" />
          <div className="pl-4" data-id="element-18">
            <SidebarItem label="Campaigns" active={false} data-id="element-19" />
            <SidebarItem label="Ads" active={false} data-id="element-20" />
            <SidebarItem label="Audiences" active={false} data-id="element-21" />
          </div>
          <SidebarItem label="Pulse" active={false} data-id="element-22" />
          <div className="pt-4" data-id="element-23">
            <div className="text-xs text-gray-500 font-semibold mb-2" data-id="element-24">
              SETTINGS
            </div>
            <SidebarItem label="Channels" active={false} data-id="element-25" />
            <SidebarItem label="Billing" active={true} data-id="element-26" />
          </div>
        </ul>
      </nav>
      <div className="p-4 text-xs text-gray-500" data-id="element-27">
        <div className="flex items-center mb-2" data-id="element-28">
          <span data-id="element-29">Terms and Conditions</span>
        </div>
        <div className="flex items-center" data-id="element-30">
          <span data-id="element-31">Privacy Policy</span>
        </div>
      </div>
    </div>;
};
const SidebarItem = ({
  label,
  active
}) => {
  return <li className={`px-2 py-1.5 rounded-md ${active ? 'bg-blue-50 text-blue-600' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-32">
      <a href="#" className="flex items-center" data-id="element-33">
        <span data-id="element-34">{label}</span>
      </a>
    </li>;
};